import styles from './Heading.module.scss'
import { HeadingProps } from './types'
export default function Heading({ title = null }: HeadingProps) {
    if (!title) {
        return null
    }

    return (
        <>
            <h3 className={styles.heading}>{title}</h3>
        </>
    )
}
